export default "__VITE_ASSET__DF1lEG5U__"